import { Stack, Typography } from '@prenuvo/halo';

import { usePatientDocs } from '../use-patient-docs.hook';
import { DocumentsByStudy } from './documents-by-study.component';

export function PreviousStudiesDocs() {
  const { previousStudyDocs } = usePatientDocs();

  return (
    <>
      <Typography
        className="py-2 dark:text-neutral-400"
        translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.PREVIOUS_STUDIES"
        variant="paragraph-md"
      />

      <Stack gap={3} variant="vertical">
        {previousStudyDocs.map(([studyId, { documents, mhsLink, radiologyReportLink, study }]) => (
          <DocumentsByStudy
            key={studyId}
            documents={documents}
            mhsLink={mhsLink}
            radiologyReportLink={radiologyReportLink}
            study={study}
          />
        ))}
      </Stack>
    </>
  );
}
